import React from "react";
import styles from "./UserProfilePopup.module.css";

// `contentClassName` lets callers widen/restyle the inner panel (e.g. the
// Edit Profile modal) without affecting the existing image-change usage, which
// passes nothing and keeps the original look. `hideClose` lets a caller render
// its own close affordance inside the body.
const Modal = ({ isOpen, onClose, children, contentClassName = "", hideClose = false }) => {
  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div
        className={`${styles.modalContent} ${contentClassName}`.trim()}
        onClick={(e) => e.stopPropagation()}
      >
        {!hideClose && (
          <button className={styles.closeButton} onClick={onClose}>
            &times;
          </button>
        )}
        <div className={styles.modalBody}>{children}</div>
      </div>
    </div>
  );
};

export default Modal;
